import {
    SET_TAB_NAME
} from '../actions/actionTypes';

export const setTabName = (tabName) => {    
    return {
        type: SET_TAB_NAME,
        data: tabName
    }    
}